module.exports = "/assets/9c0aeb26e9f0c3c330333fe19d754a54.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/IZ.png
// module id = 1492
// module chunks = 0